import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 0px;
  box-sizing: border-box;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 10px 0px;
`;

export const LineSeparatorSets = styled.div`
  width: 100%;
  height: 1px;
  margin: 0px 0px 0px 0px;
  background-color: #dedede;
`;

export const SetsRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 16px 18px 12px;
`;

export const SetsTitle = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8d8d8d;
  padding: 0px 0px 14px 0px;
`;

export const FieldTitle = styled.span`
  font-family: Roboto;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  display: flex;
  flex-direction: row;
`;

export const LineSeparator = styled.div`
  width: 100%;
  height: 1px;
  margin: 19px 0px 9px 0px;
  background-color: #c4c4c4;
`;

export const VisibilityIconContainer = styled.div`
  cursor: pointer;
  margin: 0px 0px 0px 5px;
`;
